<template>
  <div v-if="project && pages" class="presentation-print">
    <MasterPresentationPrintPage01
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage02
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage03
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage04
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage05
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage06
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage07
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage08
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage09
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage10
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage11
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage12
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage13
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage14
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage15
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage16
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage17
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage18
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage19
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage20
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage21
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage22
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage23
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage24
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage25
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage26
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage27
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage28
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage29
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage30
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage31
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage32
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage33
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage34
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage35
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage36
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage37
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage38
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage39
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage40
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage41
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage42
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage43
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
    <MasterPresentationPrintPage44
      :page-number="currentPage()"
      :page-count="masterPresentationPageCount"
      :project="project"
    />
  </div>
  <div v-else>{{ $t('no_data_found') }}</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MasterPresentationPrintPage01 from '@/views/MasterPresentation/MasterPresentationPrintPage01';
import MasterPresentationPrintPage02 from '@/views/MasterPresentation/MasterPresentationPrintPage02';
import MasterPresentationPrintPage03 from '@/views/MasterPresentation/MasterPresentationPrintPage03';
import MasterPresentationPrintPage04 from '@/views/MasterPresentation/MasterPresentationPrintPage04';
import MasterPresentationPrintPage05 from '@/views/MasterPresentation/MasterPresentationPrintPage05';
import MasterPresentationPrintPage06 from '@/views/MasterPresentation/MasterPresentationPrintPage06';
import MasterPresentationPrintPage07 from '@/views/MasterPresentation/MasterPresentationPrintPage07';
import MasterPresentationPrintPage08 from '@/views/MasterPresentation/MasterPresentationPrintPage08';
import MasterPresentationPrintPage09 from '@/views/MasterPresentation/MasterPresentationPrintPage09';
import MasterPresentationPrintPage10 from '@/views/MasterPresentation/MasterPresentationPrintPage10';
import MasterPresentationPrintPage11 from '@/views/MasterPresentation/MasterPresentationPrintPage11';
import MasterPresentationPrintPage12 from '@/views/MasterPresentation/MasterPresentationPrintPage12';
import MasterPresentationPrintPage13 from '@/views/MasterPresentation/MasterPresentationPrintPage13';
import MasterPresentationPrintPage14 from '@/views/MasterPresentation/MasterPresentationPrintPage14';
import MasterPresentationPrintPage15 from '@/views/MasterPresentation/MasterPresentationPrintPage15';
import MasterPresentationPrintPage16 from '@/views/MasterPresentation/MasterPresentationPrintPage16';
import MasterPresentationPrintPage17 from '@/views/MasterPresentation/MasterPresentationPrintPage17';
import MasterPresentationPrintPage18 from '@/views/MasterPresentation/MasterPresentationPrintPage18';
import MasterPresentationPrintPage19 from '@/views/MasterPresentation/MasterPresentationPrintPage19';
import MasterPresentationPrintPage20 from '@/views/MasterPresentation/MasterPresentationPrintPage20';
import MasterPresentationPrintPage21 from '@/views/MasterPresentation/MasterPresentationPrintPage21';
import MasterPresentationPrintPage22 from '@/views/MasterPresentation/MasterPresentationPrintPage22';
import MasterPresentationPrintPage23 from '@/views/MasterPresentation/MasterPresentationPrintPage23';
import MasterPresentationPrintPage24 from '@/views/MasterPresentation/MasterPresentationPrintPage24';
import MasterPresentationPrintPage25 from '@/views/MasterPresentation/MasterPresentationPrintPage25';
import MasterPresentationPrintPage26 from '@/views/MasterPresentation/MasterPresentationPrintPage26';
import MasterPresentationPrintPage27 from '@/views/MasterPresentation/MasterPresentationPrintPage27';
import MasterPresentationPrintPage28 from '@/views/MasterPresentation/MasterPresentationPrintPage28';
import MasterPresentationPrintPage29 from '@/views/MasterPresentation/MasterPresentationPrintPage29';
import MasterPresentationPrintPage30 from '@/views/MasterPresentation/MasterPresentationPrintPage30';
import MasterPresentationPrintPage31 from '@/views/MasterPresentation/MasterPresentationPrintPage31';
import MasterPresentationPrintPage32 from '@/views/MasterPresentation/MasterPresentationPrintPage32';
import MasterPresentationPrintPage33 from '@/views/MasterPresentation/MasterPresentationPrintPage33';
import MasterPresentationPrintPage34 from '@/views/MasterPresentation/MasterPresentationPrintPage34';
import MasterPresentationPrintPage35 from '@/views/MasterPresentation/MasterPresentationPrintPage35';
import MasterPresentationPrintPage36 from '@/views/MasterPresentation/MasterPresentationPrintPage36';
import MasterPresentationPrintPage37 from '@/views/MasterPresentation/MasterPresentationPrintPage37';
import MasterPresentationPrintPage38 from '@/views/MasterPresentation/MasterPresentationPrintPage38';
import MasterPresentationPrintPage39 from '@/views/MasterPresentation/MasterPresentationPrintPage39';
import MasterPresentationPrintPage40 from '@/views/MasterPresentation/MasterPresentationPrintPage40';
import MasterPresentationPrintPage41 from '@/views/MasterPresentation/MasterPresentationPrintPage41';
import MasterPresentationPrintPage42 from '@/views/MasterPresentation/MasterPresentationPrintPage42';
import MasterPresentationPrintPage43 from '@/views/MasterPresentation/MasterPresentationPrintPage43';
import MasterPresentationPrintPage44 from '@/views/MasterPresentation/MasterPresentationPrintPage44';

const MASTER_PRESENTATION_PRINT_PAGE_COUNT = 45;

export default {
  components: {
    MasterPresentationPrintPage01,
    MasterPresentationPrintPage02,
    MasterPresentationPrintPage03,
    MasterPresentationPrintPage04,
    MasterPresentationPrintPage05,
    MasterPresentationPrintPage06,
    MasterPresentationPrintPage07,
    MasterPresentationPrintPage08,
    MasterPresentationPrintPage09,
    MasterPresentationPrintPage10,
    MasterPresentationPrintPage11,
    MasterPresentationPrintPage12,
    MasterPresentationPrintPage13,
    MasterPresentationPrintPage14,
    MasterPresentationPrintPage15,
    MasterPresentationPrintPage16,
    MasterPresentationPrintPage17,
    MasterPresentationPrintPage18,
    MasterPresentationPrintPage19,
    MasterPresentationPrintPage20,
    MasterPresentationPrintPage21,
    MasterPresentationPrintPage22,
    MasterPresentationPrintPage23,
    MasterPresentationPrintPage24,
    MasterPresentationPrintPage25,
    MasterPresentationPrintPage26,
    MasterPresentationPrintPage27,
    MasterPresentationPrintPage28,
    MasterPresentationPrintPage29,
    MasterPresentationPrintPage30,
    MasterPresentationPrintPage31,
    MasterPresentationPrintPage32,
    MasterPresentationPrintPage33,
    MasterPresentationPrintPage34,
    MasterPresentationPrintPage35,
    MasterPresentationPrintPage36,
    MasterPresentationPrintPage37,
    MasterPresentationPrintPage38,
    MasterPresentationPrintPage39,
    MasterPresentationPrintPage40,
    MasterPresentationPrintPage41,
    MasterPresentationPrintPage42,
    MasterPresentationPrintPage43,
    MasterPresentationPrintPage44,
  },

  props: {
    projectNumber: {
      required: true,
      default: null,
    },
  },

  data() {
    return {
      number: null,
    };
  },

  computed: {
    ...mapGetters(['getProjectByNumber']),
    pages() {
      return true;
    },
    masterPresentationPageCount() {
      return MASTER_PRESENTATION_PRINT_PAGE_COUNT;
    },
    project() {
      return this.getProjectByNumber(this.number);
    },
  },

  methods: {
    ...mapActions(['fetchProjectWithFinModelByNumber']),
    currentPage() {
      this.pageCounter += 1;
      return this.pageCounter;
    },
  },

  async mounted() {
    this.number = this.projectNumber;
    await this.fetchProjectWithFinModelByNumber(this.number);
  },

  created() {
    this.pageCounter = 0;
  },
};
</script>

<style lang="scss" src="./MasterPresentationPrint.scss"></style>
